<template>
	<view class="content"></view>
</template>

<script>
	var main, receiver, filter;
	var _codeQueryTag = false;
	export default {
		data() {
			return {
				scanCode: ''
			}
		},
		created: function(option) {
			// #ifdef APP-PLUS
			this.initScan()
			this.startScan();
			// #endif



		},
		onHide: function() {
			// #ifdef APP-PLUS
			this.stopScan();
			// #endif

		},
		destroyed: function() {
			// #ifdef APP-PLUS
			this.stopScan();
			// #endif

		},
		methods: {
			byteToString(arr) {
				if (typeof arr === 'string') {
					return arr;
				}
				var str = '',
					_arr = arr;
				for (var i = 0; i < _arr.length; i++) {
					var one = _arr[i].toString(2),
						v = one.match(/^1+?(?=0)/);
					if (v && one.length == 8) {
						var bytesLength = v[0].length;
						var store = _arr[i].toString(2).slice(7 - bytesLength);
						for (var st = 1; st < bytesLength; st++) {
							store += _arr[st + i].toString(2).slice(2);
						}
						str += String.fromCharCode(parseInt(store, 2));
						i += bytesLength - 1;
					} else {
						str += String.fromCharCode(_arr[i]);
					}
				}
				return str;
			},
			initScan() {
				let _this = this;
				main = plus.android.runtimeMainActivity();
				var IntentFilter = plus.android.importClass('android.content.IntentFilter');
				filter = new IntentFilter();
				//下面的addAction内改为自己的广播动作
				// filter.addAction("android.intent.ACTION_DECODE_DATA"); //尚捷PDA
				filter.addAction("com.rfid.SCAN"); //戴莉PDA
				// filter.addAction("com.kocheer.pad.BROADCAST"); //科启奥PDA
				receiver = plus.android.implements('io.dcloud.feature.internal.reflect.BroadcastReceiver', {
					onReceive: function(context, intent) {
						plus.android.importClass(intent);
						console.log(context, intent)
						//下面的getStringExtra内改为自己的广播标签
						// let code = intent.getStringExtra("barcode_string"); //尚捷PDA
						let code = _this.byteToString(intent.getByteArrayExtra("data")); //戴莉PDA
						// let code = intent.getStringExtra("card"); //科启奥PDA
						_this.queryCode(code);
					}
				});
			},
			startScan() {
				main.registerReceiver(receiver, filter);
			},
			stopScan() {
				main.unregisterReceiver(receiver);
			},
			queryCode: function(code) {
				if (_codeQueryTag) return false;
				_codeQueryTag = true;
				setTimeout(function() {
					_codeQueryTag = false;
				}, 150);
				var id = code
				console.log('id:', id)
				uni.$emit('scan', {
					code: id
				})
			},

		}
	}
</script>